import React, { FC } from 'react'
import { CampaignSiteLayout } from '~/components/campaign/CampaignSiteLayout'

const Page: FC = () => {
  return (
    <CampaignSiteLayout
      title='DataWeave Generator (from Mapping Table)'
      description='Generate DataWeave transformations for your data mappings'
      buttonText='Generate DataWeave'
      instructions={
        <ol className='pl-2'>
          <li className='list-decimal list-inside'>
            Drag and drop your mapping table into the box below, you can also add some notes to help
            Curie understand your data better. (Example mapping tables:{' '}
            <a href='/examples/MappingTableFormat1.xlsx' target='_blank' className='text-link'>
              MappingTableFormat1
            </a>
            {', '}
            <a href='/examples/MappingTableFormat2.xlsx' target='_blank' className='text-link'>
              MappingTableFormat2
            </a>
            )
          </li>
          <li className='list-decimal list-inside'>
            Click generate to see Curie create a DataWeave transformation for your mapping table.
          </li>
        </ol>
      }
    ></CampaignSiteLayout>
  )
}

export default Page
